<template>
  <div id="app">
    <v-container>
      <Header />
      <v-overlay :value="loader">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <Booking :eventData="events" v-if="events !== null" />
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import Header from "../components/Header.vue";
import Booking from "../components/Booking.vue";
import { API } from "aws-amplify";
import moment from "moment";
export default {
  components: {
    Header,
    Booking,
  },
  async created() {
    this.loader = true;
    const eventQuery = `query ListEvents($assignedTo: String! $date: String) {
      listEvents(
          limit:1000,
          filter: {
            isDeleted: { eq: 0 }
          }
      ) {
          items {
              eventCompany {
                id
                name
              },
              id
              name
              code
              status
              type
              iCalendar
              attendance
              eventLocation (
                filter: {
                  isDeleted: { eq: 0 }
                }
              ) {
                  items {
                      id
                      addressLine1
                      postcode
                      town
                      createdAt
                      eventSlotGroup(
                        limit: 1000
                        filter: {
                          isDeleted: { eq: 0 },
                          assignedTo: { contains: $assignedTo },
                          date: { gt: $date }
                        }
                      ) {
                          items {
                              id
                              room
                              createdAt
                              date
                              capacity
                              eventSlot(limit: 1000) {
                                  items {
                                      id
                                      length
                                      time
                                      type
                                      booked
                                      eventBooking(
                                        limit: 1000
                                        filter: {
                                          isDeleted: { eq: 0 }
                                        }
                                      ) {
                                        items {
                                          id
                                          firstname
                                          lastname
                                          email
                                          dob
                                          mobile
                                          attendance
                                          isDeleted
                                        }
                                      }
                                  }
                              }
                          }
                      }
                  }
              },
              eventCollectUserData {
                items {
                  id,
                  label,
                  validation,
                  fieldType,
                  createdAt,
                  isDeleted,
                  eventCollectUserDataOptions {
                    items {
                      id,
                      options
                    }
                  }
                }
              }
          }
      }
    }`;

    const listEventSlotGroups = /* GraphQL */ `
      query ListEventSlotGroups(
        $filter: ModelEventSlotGroupFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listEventSlotGroups(
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            id
            room
            createdAt
            date
            capacity
            assignedTo
            eventSlot(limit: 1000) {
              items {
                id
                length
                time
                type
                booked
                eventBooking {
                  items {
                    id
                    firstname
                    lastname
                    email
                    dob
                    mobile
                    attendance
                    customData
                    isDeleted
                  }
                }
              }
            }
            eventLocation {
              addressLine1
              addressLine2
              createdAt
              eventLocationLookupId
              id
              isDeleted
              postcode
              town
              updatedAt
              event {
                eventCompany {
                  id
                  name
                }
                id
                name
                code
                status
                type
                iCalendar
                attendance
                eventCollectUserData {
                  items {
                    id
                    label
                    validation
                    fieldType
                    createdAt
                    isDeleted
                    eventCollectUserDataOptions {
                      items {
                        id
                        options
                      }
                    }
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const date = moment().subtract(1, "day").format("YYYY-MM-DD");

    Auth.currentAuthenticatedUser().then(async (user) => {
      const events = await API.graphql({
        query: eventQuery,
        variables: {
          assignedTo: user.attributes.email,
          date: date,
        },
        authMode: "API_KEY",
      });
      this.events = events.data.listEvents.items;
      this.loader = false;
    });
  },
  data() {
    return {
      loader: false,
      events: null,
    };
  },
};
</script>